import React from "react";

const Key = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-key"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-key"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="m22 0h-1.436a2.978 2.978 0 0 0 -2.121.879l-8.527 8.521a7.518 7.518 0 1 0 4.684 4.684l2.4-2.4v-3.684h3v-3h3.551a2.978 2.978 0 0 0 .449-1.564v-1.436a2 2 0 0 0 -2-2zm-16.5 20a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1 -1.5 1.5z" />
    </svg>
  );
};

export default Key;
